export var TEMPORARY_COVER_STATUTORY_LIMIT_KEY = 999999999;
export var TEMPORARY_COVER_STATUTORY_LIMIT_TEXT = 'Statutory limit';